import { trace } from 'rytm-helpers'
import { store } from './../store'
import { offcanvasShow, offcanvasHide } from './../actions/actions_gui'
import { pauseSoundMain, resumeSoundMain } from './../actions/actions_audio'
import { pauseVideoMain, resumeVideoMain } from './../actions/actions_video'

/**
 * ############
 * ### INIT ###
 */
 export const initTsawGui = () => {
  store.subscribe(onStoreChange)
  // DOM event listeners
  // offcanvas show / hide
  const docEl = document.documentElement
  docEl.addEventListener("show.bs.offcanvas", onOffcanvasShow)
  docEl.addEventListener("shown.bs.offcanvas", onOffcanvasShown)
  docEl.addEventListener("hide.bs.offcanvas", onOffcanvasHide)
  docEl.addEventListener("hidden.bs.offcanvas", onOffcanvasHidden)
}
/**
 * ########################
 * # State event handlers #
 */
const onStoreChange = () => {
  const state = store.getState()
  // Boolean loadingView
  if (state.reducerGui.loadingView) {
    document.documentElement.classList.add("view-loading")
  } else {
    document.documentElement.classList.remove("view-loading")
  }
  // Media queue length
  // trace("MEDIA QUQUE", state.reducerGui.mediaQueue.length)
  if (state.reducerGui.mediaQueue.length > 0) {
    document.documentElement.classList.add("media-loading")
  } else {
    document.documentElement.classList.remove("media-loading")
  }
}
/**
 * ##########################
 * ### DOM event handlers ###
 */
 const onOffcanvasShow = (e) => {
  offcanvasShow()
  pauseSoundMain()
  pauseVideoMain()
  const classNames = e.target.dataset.htmlClass
  if (classNames) {
    const listClasses = classNames.split(" ")
    listClasses.forEach((classN) => {
      document.documentElement.classList.add(classN)
    })
  }
}
const onOffcanvasShown = (e) => {

}
const onOffcanvasHide = (e) => {
  offcanvasHide()
  resumeSoundMain()
  resumeVideoMain()
  const classNames = e.target.dataset.htmlClass
  if (classNames) {
    const listClasses = classNames.split(" ")
    listClasses.forEach((classN) => {
      document.documentElement.classList.remove(classN)
    })
  }
}
const onOffcanvasHidden = (e) => {
  
}